
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34153',
  depVersions: {
  "documents-public-ui": "static-1.34153",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34158",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1999",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.101",
  "hs-promise-utils": "static-1.5468",
  "hs-test-utils": "static-1.7883",
  "hub-http": "static-1.6092",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11316",
  "I18n": "static-7.1598",
  "jasmine-immutable": "static-1.2890",
  "jasmine-runner": "static-1.6343",
  "lodash": "static-1.3",
  "quartz": "static-1.6829",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16525",
  "reporting-data": "static-1.66843",
  "reporting-testing-lib": "static-1.8776",
  "reporting-visualizations": "static-1.58919",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4641",
  "webpack-env": "static-1.54",
  "atom": "static-1.4943",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2366",
  "classnames": "static-2.10",
  "cssUtils": "static-1.764",
  "customer-data-filters-ui": "static-1.39176",
  "customer-data-objects": "static-1.7527",
  "customer-data-property-utils": "static-1.7954",
  "data-fetching-client": "static-1.9549",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4403",
  "flux-actions": "static-1.323",
  "FormsCommonComponents": "static-1.85477",
  "FormUrlGenerator": "static-2.4594",
  "foundations-components": "static-1.7661",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11624",
  "icons": "static-2.637",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7033",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3727",
  "property-translator": "static-1.5281",
  "quartz-config": "static-1.607",
  "quartz-core": "static-1.6048",
  "quick-fetch": "static-1.3807",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5242",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8038",
  "reference-resolvers-lite": "static-1.7958",
  "report-customization-components": "static-1.12734",
  "reporting-enablement": "static-1.22356",
  "reporting-reports": "static-1.66521",
  "reporting-snowflake": "static-1.55461",
  "reporting-ui-components": "static-2.64114",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4517",
  "sales-content-partitioning": "static-1.8809",
  "SalesContentIndexUI": "static-3.9023",
  "sanitize": "static-1.4347",
  "sanitize-text": "static-1.8018",
  "self-service-api": "static-1.10115",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1625",
  "signup-constants": "static-1.18565",
  "signup-ui-lego-core": "static-1.20575",
  "signup-ui-url-generator": "static-2.7908",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4641",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10865",
  "ui-addon-i18n": "static-1.11019",
  "ui-addon-react-router-dom": "static-1.9418",
  "ui-addon-upgrades": "static-9.17775",
  "ui-asset-management-lib": "static-1.10820",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8263",
  "usage-tracker": "static-1.7209",
  "usage-tracker-container": "static-1.7199",
  "usage-tracker-core": "static-1.7059",
  "usage-tracker-public": "static-1.7020",
  "viral-links-lib": "static-1.6912",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3106",
  "quartz-webpack": "static-1.3053",
  "ai-components-ui-library": "static-1.8573",
  "amplitude-session-replay-browser": "static-1.57",
  "foundations-assets": "static-1.4713",
  "foundations-theming": "static-1.4283",
  "quartz-auth": "static-1.504",
  "ui-business-units-lib": "static-1.8907",
  "usage-tracker-session-replay": "static-1.4895",
  "foundations-theming-base": "static-1.3268",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.2994",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4198",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7797",
  "graphql": "static-1.79",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3582",
  "reporting-client-types": "static-1.2414",
  "foundations-components-legacy": "static-1.686",
  "hs-story-utils": "static-1.9300",
  "react-flip-move": "static-1.67",
  "hub-http-shared-msw-handlers": "static-1.9655",
  "hubspotter-http": "static-1.4547",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7121",
  "crm-message-bus": "static-1.42591",
  "customer-data-filters-ui-msw-helpers": "static-1.21611",
  "customer-data-objects-ui-components": "static-1.12886",
  "customer-data-reference-ui-components": "static-1.13022",
  "customer-data-ui-utilities": "static-1.9697",
  "framework-builder-read-service-client": "static-1.3902",
  "framework-data-schema-quick-fetch": "static-1.6652",
  "framework-data-schema-resolvers": "static-1.6747",
  "inbound-db-properties-service-client": "static-1.3740",
  "multi-account-reference-resolvers": "static-1.851",
  "onboarding-tours": "static-1.16368",
  "reporting-datasets-permissions-lib": "static-1.13273",
  "ui-addon-teams": "static-1.21352",
  "apollo-stack-hubspot": "static-3.83",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67852",
  "customer-data-properties": "static-1.51030",
  "forms-ai-lib": "static-1.4113",
  "forms-utils-lib": "static-1.12320",
  "foundations-components-test-utils": "static-1.5144",
  "react-dnd-compat": "static-1.4492",
  "react-tinymce": "static-1.54836",
  "tinymce-config": "static-2.53962",
  "ui-gdpr-components": "static-1.10221",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3930",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1423",
  "ui-fonts": "static-1.578",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-head": "static-1.494",
  "quartz-i18n": "static-1.504",
  "quartz-routing": "static-1.259",
  "quartz-test": "static-1.504",
  "quartz-tracking": "static-1.208",
  "batch-promise": "static-1.1425",
  "external-options-client-types": "static-1.4053",
  "react-colorpicker": "static-2.10083",
  "copilot-toolkit": "static-1.10739",
  "data-quality-ui-library": "static-1.12514",
  "html-to-image": "static-1.51",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6336",
  "reporting-action-components": "static-1.40858",
  "reporting-insights-lib": "static-1.1288",
  "reporting-plugins": "static-1.10072",
  "ui-addon-draggable-compat": "static-2.4127",
  "ui-addon-opt": "static-4.8257",
  "ui-shepherd-react": "static-3.10019",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24938",
  "hubspot-apollo-client": "static-1.4752",
  "chirp-fetch": "static-1.1755",
  "sales-templates-service-types-lib": "static-1.4061",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5613",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3974",
  "timezone-utils": "static-2.5117",
  "bender-build-tools": "static-1.3025",
  "chatspot-core": "static-1.20647",
  "bend-plugin-foundations-theming": "static-1.2766",
  "stylex": "static-1.29",
  "hubspotter-http-shared-msw-handlers": "static-1.9653",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3692",
  "crm-pipelines-api-client-types": "static-1.4036",
  "multi-currency-client-types": "static-1.3584",
  "getting-started-shared-tasks": "static-1.18090",
  "growth-data-modal": "static-1.5233",
  "growth-onboarding-confetti": "static-1.2945",
  "growth-onboarding-next-action-utils": "static-1.1496",
  "navigation-components": "static-1.17532",
  "onboarding-tours-client": "static-1.4582",
  "onboarding-tours-utils": "static-1.434",
  "ui-shepherd-tracker": "static-1.7400",
  "ui-universal-auth": "static-1.8794",
  "user-context": "static-1.4973",
  "cms-field-types": "static-1.4681",
  "content-icons-ui": "static-1.2188",
  "integrations-lib": "static-1.15655",
  "calling-global-api": "static-1.63960",
  "calling-internal-common": "static-1.31173",
  "calling-lifecycle-internal": "static-1.65342",
  "calling-lifecycle-messages": "static-1.57636",
  "commerce-products-lib": "static-1.9054",
  "crm-links": "static-1.6143",
  "file-manager-components": "static-1.23156",
  "google-libphonenumber": "static-1.35",
  "hs-entities": "static-1.564",
  "inbounddb-objects-service-types": "static-1.4117",
  "meetings-icalendar-utils-lib": "static-1.504",
  "object-builder-ui-client": "static-1.48261",
  "pipeline-validation-client-types": "static-1.3858",
  "property-value-citations": "static-1.1645",
  "pulse": "static-1.403",
  "smart-property-lib": "static-1.6244",
  "tiered-pricing": "static-1.950",
  "ui-addon-iframeable": "static-1.8921",
  "final-form": "static-1.67",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19603",
  "tinymce-themes": "static-1.55932",
  "data-token-picker": "static-1.16174",
  "hub-http-contrib": "static-1.2916",
  "interframe": "static-3.4635",
  "tinymce-data": "static-1.40047",
  "tinymce-plugins": "static-1.57076",
  "ui-addon-sales-email": "static-1.5086",
  "magpie-lib": "static-1.5467",
  "magpie-types": "static-1.4927",
  "simple-logging-lib": "static-1.2923",
  "content-assistance-lib": "static-1.7553",
  "dashboard-lib": "static-1.80937",
  "ExportDialog": "static-6.10262",
  "hubspot-prosemirror": "static-1.17822",
  "hubspot-prosemirror-plugins": "static-1.17814",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8566",
  "campaign-roi-lib": "static-1.8508",
  "feedback-loader": "static-1.29023",
  "apollo-link-hub-http": "static-2.4524",
  "hubspot-apollo-cache": "static-1.211",
  "growth-monetization-service-types": "static-1.4371",
  "nav-client-types": "static-1.2230",
  "purchase-motions-api": "static-1.5616",
  "trials-service-types": "static-1.3772",
  "growth-onboarding-next-action-components": "static-1.1524",
  "user-context-client": "static-1.4485",
  "idb-keyval": "static-1.41",
  "nest": "static-1.94",
  "reactive-lib": "static-1.597",
  "unified-auth-core-lib": "static-1.589",
  "getting-started-shared-tasks-store": "static-1.17208",
  "integrations-error-boundary-lib": "static-1.13070",
  "integrations-tracking-lib": "static-1.5464",
  "native-integrations-shared-strings": "static-1.7659",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10247",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.308",
  "calling-error-reporting": "static-1.31179",
  "shared-worker-versioning": "static-1.10912",
  "calling-usage-tracker": "static-1.6414",
  "voice-sms-access-library": "static-1.465",
  "customer-data-tracking": "static-1.6756",
  "commerce-permissions": "static-1.637",
  "products-iframe-lib": "static-1.7540",
  "products-ui-components-shared-msw-handlers": "static-1.10037",
  "location-customization-utils-lib": "static-1.8793",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4026",
  "video-components-external": "static-1.10805",
  "video-data-lib": "static-1.34463",
  "hs-resources": "static-1.6",
  "directed-graph": "static-1.811",
  "event-emitter": "static-1.820",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5426",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9738",
  "fsm": "static-1.3604",
  "policy-lib": "static-1.6652",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9801",
  "navigation-messaging": "static-1.6859",
  "FileManagerLib": "static-1.38796",
  "NamespacedHubStyle": "static-2.8963",
  "FileManagerCore": "static-1.38655",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12189",
  "layout-dnd-utils": "static-1.11164",
  "react-codemirror": "static-1.10498",
  "ui-addon-emoji-picker": "static-1.9760",
  "ui-brand-identity-lib": "static-1.14426",
  "ui-addon-video-player": "static-1.8568",
  "ui-coaching-tips": "static-1.28144",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8431",
  "payment-link-components": "static-1.23136",
  "EmailSignatureEditor": "static-1.24055",
  "eligibility-engine-service-types": "static-1.3053",
  "universal-page-editor-lib": "static-1.2874",
  "calling-orchestration-schema": "static-1.35242",
  "sales-views-client-types": "static-1.4136",
  "crm-record-cards-service-types": "static-1.3511",
  "content-media-composition-data-lib": "static-1.11752",
  "content-media-compositions": "static-2.15759",
  "media-bridge-lib": "static-1.18697",
  "trellis-story-utils": "static-1.4393",
  "storybook-react": "static-1.30",
  "audio-components": "static-1.5716",
  "FileManagerImages": "static-1.36307",
  "video-components": "static-1.12808",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4405",
  "video-embed": "static-1.35297",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67927",
  "layout-data-lib": "static-1.9489",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6454",
  "commerce-tours-lib": "static-1.5843",
  "growth-onboarding-reliability": "static-1.4959",
  "sales-checkout-service-client": "static-1.3541",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21441",
  "sales-email-signature-service-client": "static-1.3716",
  "social-insights-client-types": "static-1.21618",
  "outpost": "static-1.4071",
  "advanced-menus-core": "static-1.14923",
  "advanced-menus-lib": "static-1.11889",
  "ui-memberships-settings-lib": "static-1.33653",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14922",
  "simple-menus-lib": "static-1.16439"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34153",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34158",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.101",
  "hs-promise-utils": "/hs-promise-utils/static-1.5468",
  "hs-test-utils": "/hs-test-utils/static-1.7883",
  "hub-http": "/hub-http/static-1.6092",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11316",
  "I18n": "/I18n/static-7.1598",
  "jasmine-immutable": "/jasmine-immutable/static-1.2890",
  "jasmine-runner": "/jasmine-runner/static-1.6343",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6829",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16525",
  "reporting-data": "/reporting-data/static-1.66843",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8776",
  "reporting-visualizations": "/reporting-visualizations/static-1.58919",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4641",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4943",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2366",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39176",
  "customer-data-objects": "/customer-data-objects/static-1.7527",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7954",
  "data-fetching-client": "/data-fetching-client/static-1.9549",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4403",
  "flux-actions": "/flux-actions/static-1.323",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85477",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4594",
  "foundations-components": "/foundations-components/static-1.7661",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11624",
  "icons": "/icons/static-2.637",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7033",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3727",
  "property-translator": "/property-translator/static-1.5281",
  "quartz-config": "/quartz-config/static-1.607",
  "quartz-core": "/quartz-core/static-1.6048",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5242",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8038",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7958",
  "report-customization-components": "/report-customization-components/static-1.12734",
  "reporting-enablement": "/reporting-enablement/static-1.22356",
  "reporting-reports": "/reporting-reports/static-1.66521",
  "reporting-snowflake": "/reporting-snowflake/static-1.55461",
  "reporting-ui-components": "/reporting-ui-components/static-2.64114",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4517",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8809",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9023",
  "sanitize": "/sanitize/static-1.4347",
  "sanitize-text": "/sanitize-text/static-1.8018",
  "self-service-api": "/self-service-api/static-1.10115",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1625",
  "signup-constants": "/signup-constants/static-1.18565",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20575",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7908",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4641",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10865",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11019",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9418",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17775",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10820",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8263",
  "usage-tracker": "/usage-tracker/static-1.7209",
  "usage-tracker-container": "/usage-tracker-container/static-1.7199",
  "usage-tracker-core": "/usage-tracker-core/static-1.7059",
  "usage-tracker-public": "/usage-tracker-public/static-1.7020",
  "viral-links-lib": "/viral-links-lib/static-1.6912",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3106",
  "quartz-webpack": "/quartz-webpack/static-1.3053",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8573",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4713",
  "foundations-theming": "/foundations-theming/static-1.4283",
  "quartz-auth": "/quartz-auth/static-1.504",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8907",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4895",
  "foundations-theming-base": "/foundations-theming-base/static-1.3268",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4198",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7797",
  "graphql": "/graphql/static-1.79",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3582",
  "reporting-client-types": "/reporting-client-types/static-1.2414",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.686",
  "hs-story-utils": "/hs-story-utils/static-1.9300",
  "react-flip-move": "/react-flip-move/static-1.67",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9655",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7121",
  "crm-message-bus": "/crm-message-bus/static-1.42591",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21611",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12886",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13022",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9697",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.851",
  "onboarding-tours": "/onboarding-tours/static-1.16368",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13273",
  "ui-addon-teams": "/ui-addon-teams/static-1.21352",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67852",
  "customer-data-properties": "/customer-data-properties/static-1.51030",
  "forms-ai-lib": "/forms-ai-lib/static-1.4113",
  "forms-utils-lib": "/forms-utils-lib/static-1.12320",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5144",
  "react-dnd-compat": "/react-dnd-compat/static-1.4492",
  "react-tinymce": "/react-tinymce/static-1.54836",
  "tinymce-config": "/tinymce-config/static-2.53962",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10221",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3930",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1423",
  "ui-fonts": "/ui-fonts/static-1.578",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-head": "/quartz-head/static-1.494",
  "quartz-i18n": "/quartz-i18n/static-1.504",
  "quartz-routing": "/quartz-routing/static-1.259",
  "quartz-test": "/quartz-test/static-1.504",
  "quartz-tracking": "/quartz-tracking/static-1.208",
  "batch-promise": "/batch-promise/static-1.1425",
  "external-options-client-types": "/external-options-client-types/static-1.4053",
  "react-colorpicker": "/react-colorpicker/static-2.10083",
  "copilot-toolkit": "/copilot-toolkit/static-1.10739",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12514",
  "html-to-image": "/html-to-image/static-1.51",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6336",
  "reporting-action-components": "/reporting-action-components/static-1.40858",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1288",
  "reporting-plugins": "/reporting-plugins/static-1.10072",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4127",
  "ui-addon-opt": "/ui-addon-opt/static-4.8257",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10019",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24938",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4752",
  "chirp-fetch": "/chirp-fetch/static-1.1755",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4061",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5613",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3974",
  "timezone-utils": "/timezone-utils/static-2.5117",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "chatspot-core": "/chatspot-core/static-1.20647",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
  "stylex": "/stylex/static-1.29",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9653",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18090",
  "growth-data-modal": "/growth-data-modal/static-1.5233",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2945",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1496",
  "navigation-components": "/navigation-components/static-1.17532",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4582",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.434",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7400",
  "ui-universal-auth": "/ui-universal-auth/static-1.8794",
  "user-context": "/user-context/static-1.4973",
  "cms-field-types": "/cms-field-types/static-1.4681",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "integrations-lib": "/integrations-lib/static-1.15655",
  "calling-global-api": "/calling-global-api/static-1.63960",
  "calling-internal-common": "/calling-internal-common/static-1.31173",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65342",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57636",
  "commerce-products-lib": "/commerce-products-lib/static-1.9054",
  "crm-links": "/crm-links/static-1.6143",
  "file-manager-components": "/file-manager-components/static-1.23156",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-entities": "/hs-entities/static-1.564",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.504",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48261",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
  "property-value-citations": "/property-value-citations/static-1.1645",
  "pulse": "/pulse/static-1.403",
  "smart-property-lib": "/smart-property-lib/static-1.6244",
  "tiered-pricing": "/tiered-pricing/static-1.950",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8921",
  "final-form": "/final-form/static-1.67",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19603",
  "tinymce-themes": "/tinymce-themes/static-1.55932",
  "data-token-picker": "/data-token-picker/static-1.16174",
  "hub-http-contrib": "/hub-http-contrib/static-1.2916",
  "interframe": "/interframe/static-3.4635",
  "tinymce-data": "/tinymce-data/static-1.40047",
  "tinymce-plugins": "/tinymce-plugins/static-1.57076",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5086",
  "magpie-lib": "/magpie-lib/static-1.5467",
  "magpie-types": "/magpie-types/static-1.4927",
  "simple-logging-lib": "/simple-logging-lib/static-1.2923",
  "content-assistance-lib": "/content-assistance-lib/static-1.7553",
  "dashboard-lib": "/dashboard-lib/static-1.80937",
  "ExportDialog": "/ExportDialog/static-6.10262",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17822",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17814",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8566",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8508",
  "feedback-loader": "/feedback-loader/static-1.29023",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4524",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.211",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4371",
  "nav-client-types": "/nav-client-types/static-1.2230",
  "purchase-motions-api": "/purchase-motions-api/static-1.5616",
  "trials-service-types": "/trials-service-types/static-1.3772",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1524",
  "user-context-client": "/user-context-client/static-1.4485",
  "idb-keyval": "/idb-keyval/static-1.41",
  "nest": "/nest/static-1.94",
  "reactive-lib": "/reactive-lib/static-1.597",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.589",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17208",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13070",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5464",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7659",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10247",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.308",
  "calling-error-reporting": "/calling-error-reporting/static-1.31179",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10912",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6414",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.465",
  "customer-data-tracking": "/customer-data-tracking/static-1.6756",
  "commerce-permissions": "/commerce-permissions/static-1.637",
  "products-iframe-lib": "/products-iframe-lib/static-1.7540",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10037",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8793",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4026",
  "video-components-external": "/video-components-external/static-1.10805",
  "video-data-lib": "/video-data-lib/static-1.34463",
  "hs-resources": "/hs-resources/static-1.6",
  "directed-graph": "/directed-graph/static-1.811",
  "event-emitter": "/event-emitter/static-1.820",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5426",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9738",
  "fsm": "/fsm/static-1.3604",
  "policy-lib": "/policy-lib/static-1.6652",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9801",
  "navigation-messaging": "/navigation-messaging/static-1.6859",
  "FileManagerLib": "/FileManagerLib/static-1.38796",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
  "FileManagerCore": "/FileManagerCore/static-1.38655",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12189",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11164",
  "react-codemirror": "/react-codemirror/static-1.10498",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9760",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14426",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28144",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8431",
  "payment-link-components": "/payment-link-components/static-1.23136",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24055",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3053",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2874",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35242",
  "sales-views-client-types": "/sales-views-client-types/static-1.4136",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11752",
  "content-media-compositions": "/content-media-compositions/static-2.15759",
  "media-bridge-lib": "/media-bridge-lib/static-1.18697",
  "trellis-story-utils": "/trellis-story-utils/static-1.4393",
  "storybook-react": "/storybook-react/static-1.30",
  "audio-components": "/audio-components/static-1.5716",
  "FileManagerImages": "/FileManagerImages/static-1.36307",
  "video-components": "/video-components/static-1.12808",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4405",
  "video-embed": "/video-embed/static-1.35297",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67927",
  "layout-data-lib": "/layout-data-lib/static-1.9489",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6454",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5843",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4959",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3541",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21441",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3716",
  "social-insights-client-types": "/social-insights-client-types/static-1.21618",
  "outpost": "/outpost/static-1.4071",
  "advanced-menus-core": "/advanced-menus-core/static-1.14923",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11889",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33653",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14922",
  "simple-menus-lib": "/simple-menus-lib/static-1.16439"
}
};
